
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/historico",
      function () {
        return require("private-next-pages/[region]/[resort]/historico.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/historico"])
      });
    }
  